import { render, staticRenderFns } from "./LabelLifecycle.vue?vue&type=template&id=65334ad8&scoped=true"
import script from "./LabelLifecycle.vue?vue&type=script&lang=js"
export * from "./LabelLifecycle.vue?vue&type=script&lang=js"
import style0 from "./LabelLifecycle.vue?vue&type=style&index=0&id=65334ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65334ad8",
  null
  
)

export default component.exports